/* ═══════════════════════════════════════════════════════════════
   The Designer — the attribute set every spec block node shares, and
   the id minter. Split out of schema.ts so schema.ts and tables.ts can
   both depend on it without importing each other's whole module.
   ═══════════════════════════════════════════════════════════════ */

export type BlockMeta = Record<string, unknown>;

/** Shared attributes every spec block node carries (paragraphs, tables,
 *  images, smart tokens — every direct child of the document). */
export const blockAttrs = {
  blockId: { default: '' },
  level: { default: 1 },
  continuation: { default: false },
  excluded: { default: false },
  meta: { default: {} as BlockMeta },
};

/** Same shape the rest of the app generates, so ids stay recognisable. */
export function newBlockId(): string {
  return 'b-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
}
